import React from 'react';

const AddFavourites = () => {
    return (
        <div className="d-flex align-items-center justify-content-center">
            <span className="me-2">Add to Favourites</span>
            <i className="bi bi-heart-fill text-danger"></i>
        </div>
    );
};

export default AddFavourites;
